export default function () {
	const debug = false;
	let resizeTimeout;

	// Function to handle the dropdown shown on mobile
	function heroDropdown() {
		// handles changes on the select dropdown to trigger click on the submenu
		let select = document.querySelector('.hero-default__dropdown');

		// Check to avoid a JS error on the following line
		if (select) {
			debug ? console.log('found a dropdown select element') : false;

			select.addEventListener('change', function() {
				let selectedValue = select.options[select.selectedIndex];
				let navElement = select.previousElementSibling.querySelector('#' + selectedValue.value);

				debug ? console.log('dropdown changed to:', selectedValue.text) : false;

				if (navElement) {
					navElement.click();
				}
			});
		}
	}

	// Function to handle resizing with a delay
	function delayedResizeHandler() {
		clearTimeout(resizeTimeout);

		resizeTimeout = setTimeout(() => {
			handleResize();
		}, 500); // 500 milliseconds delay
	}

	// Function to handle resizing
	function handleResize() {
		const elements = document.querySelectorAll('.block--hero-default');

		elements.forEach(element => {
			const thumbnail = element.querySelector('.hero-default__thumbnail');

			// Check if thumbnail exists before proceeding
			if (thumbnail !== null) {
				let desktopSrc = '';
				let mobileSrc = '';

				// Check for it to avoid failing
				if (thumbnail.hasAttribute('data-desktop')) {
					desktopSrc = thumbnail.getAttribute('data-desktop');
				}

				// Check for it to avoid failing
				if (thumbnail.hasAttribute('data-mobile')) {
					mobileSrc = thumbnail.getAttribute('data-mobile');
				}

				// Get the viewport width
				const screenWidth = window.innerWidth;

				// Handle which image to display, depending on a variety of conditions
				if (desktopSrc !== '' && mobileSrc === '') {
					// If the Desktop is found WITHOUT the mobile (legacy)
					debug ? console.warn('Only the Desktop data-attribute present for element (legacy fallback)') : false;

					debug ? console.log('showing Desktop version for:', element) : false;
					thumbnail.src = desktopSrc;
				} else if (desktopSrc !== '' && mobileSrc !== '') {
					// If the Desktop AND Mobile are found (new)
					debug ? console.warn('Desktop and Mobile data-attribute present for element') : false;

					if (screenWidth > 650) {
						debug ? console.info('showing Desktop version for:', element) : false;
						thumbnail.src = desktopSrc;
					} else {
						debug ? console.info('showing Mobile version for:', element) : false;
						thumbnail.src = mobileSrc !== '' ? mobileSrc : desktopSrc;
					}
				} else {
					// If neither the Desktop or Mobile are found (not meeting requirements)
					debug ? console.error('Desktop and Mobile data-attribute is missing for element:', element) : false;
				}
			} else {
				// Handle case where thumbnail is not found
				debug ? console.error('.hero-default__thumbnail not found for element:', element) : false;
			}
		});
	}

	// Initial call
	heroDropdown();
	handleResize();

	// Event listener for window resizing with delay
	window.addEventListener('resize', delayedResizeHandler);
}
